import { Outlet, useNavigate, useOutlet } from '@remix-run/react';
import { Modal, ModalProps } from '../Modal';

interface ModalOutletProps extends Omit<ModalProps, 'title' | 'open' | 'onClose' | 'children'> {
	context?: any;
}

export function ModalOutlet({ context, ...props }: ModalOutletProps) {
	const open = !!useOutlet();
	const navigate = useNavigate();

	return (
		<Modal customPanel open={open} onClose={() => navigate('.')} {...props}>
			<Outlet context={context} />
		</Modal>
	);
}
